import underscored from 'underscore.string/underscored';

angular.module('gym.components').directive('ezidebitPaymentDetails', function() {
  return {
    restrict: 'EA',
    scope: {
      paymentMethods: '=',
      permissions: '=',
      contact: '=',
      remove: '&'
    },
    template: require('templates/components/contacts/wallet/ezidebit_payment_details.html.slim'),
    controller: ["$scope", "AdminUserService", function($scope, AdminUserService) {
      $scope.adminHasPermission = AdminUserService.has;
      return $scope.contactsType = function(type) {
        return `${underscored(type)}s`;
      };
    }]
  };
});
